const BelozIcon = () => {
    return (
        <img
            src="./images/icons/beloz-fi-icon.png"
            alt="Beloz Icon"
            style={{width: '120px', height: '100%'}}
        />
    );
};

export default BelozIcon;